import React from 'react';
import PropTypes from 'prop-types';
import toPairs from 'lodash/toPairs';
import {
  FormLabel, Select, MenuItem, FormControl,
} from '@mui/material';

import { VEHICLE_TYPES } from '../../lib/utils';

const styles = {
  formLabel: {
    textAlign: 'center',
    width: '100%',
  },
};

class VehicleTypeSelect extends React.Component {
  constructor(props) {
    super(props);
    const { value } = props;

    this.state = {
      selectedVehicleType: value,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const { handleChange } = this.props;
    const stateUpdate = { [event.target.name]: event.target.value };
    this.setState(stateUpdate);

    handleChange(event.target.value);
  }

  render() {
    const { showAll, disabled } = this.props;
    const { selectedVehicleType } = this.state;

    return (
      <FormControl component="fieldset" style={{ width: '100%' }}>
        <FormLabel component="legend" style={styles.formLabel}>Vehicle Type</FormLabel>
        <Select
          displayEmpty
          disabled={disabled}
          style={{ width: '100%' }}
          variant="standard"
          onChange={this.handleChange}
          value={selectedVehicleType}
          inputProps={{
            name: 'selectedVehicleType',
            id: 'vehicle-type-picker',
          }}
        >
          {showAll && <MenuItem value="" key="none">All</MenuItem>}
          {VEHICLE_TYPES && toPairs(VEHICLE_TYPES).map(
            ([key, name]) => (<MenuItem value={key} key={key}>{name}</MenuItem>),
          )}
        </Select>
      </FormControl>
    );
  }
}
VehicleTypeSelect.defaultProps = {
  value: '',
  disabled: false,
  showAll: true,
};
VehicleTypeSelect.propTypes = {
  handleChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  showAll: PropTypes.bool,
};

export default VehicleTypeSelect;
